import { render, staticRenderFns } from "./SalesDetailDialog.vue?vue&type=template&id=56280618&scoped=true&"
import script from "./SalesDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SalesDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SalesDetailDialog.vue?vue&type=style&index=0&id=56280618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56280618",
  null
  
)

export default component.exports